module.exports = __webpack_public_path__ + "static/1st_floor_3-c505611031f24e078a66a578ff829e1d.jpg";